<template>
    <ul class="domestic-organization">
        <li v-for="(items, type) in groupedItems" :key="type">
            <v-row class="row--xxs">
                <v-col cols="12">
                    <v-sheet color="primary" outlined rounded="pill" class="px-16 py-8">
                        <h4 class="tit tit--sm primary--text line-height-1">
                            {{ type }}
                        </h4>
                    </v-sheet>
                </v-col>
                <v-col v-for="item in items" :key="item.name" cols="12">
                    <v-sheet min-height="70" color="#fafafa" class="domestic-organization__child">
                        <v-row align="center" class="page-text page-text--lg">
                            <v-col cols="10" lg="3" order="1" class="domestic-organization__name">{{ item.name }}</v-col>
                            <v-col cols="12" lg="3" order="3" class="domestic-organization__tel">
                                {{ item.tel }}
                            </v-col>
                            <v-col cols="12" lg="" order="4" class="domestic-organization__address">
                                {{ item.address }}
                            </v-col>
                            <v-col v-if="item.site" cols="2" lg="auto" order="2" order-lg="5" class="domestic-organization__link">
                                <v-btn :href="item.site" target="_blank" icon text>
                                    <v-img src="/images/about/organization/icon-home.svg" max-width="24" alt="홈페이지로 이동" />
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-sheet>
                </v-col>
            </v-row>
        </li>
    </ul>
</template>

<script>
import organization from "@/assets/data/organization.json";

export default {
    data() {
        return {
            items: organization,
        };
    },
    computed: {
        groupedItems() {
            return this.items.reduce((acc, item) => {
                if (!acc[item.type]) acc[item.type] = [];
                acc[item.type].push(item);
                return acc;
            }, {});
        },
    },
};
</script>

<style lang="scss" scoped>
.domestic-organization {
    > li {
        &:not(:last-child) {
            padding-bottom: 60px;
        }
    }
    &__child {
        min-height: 70px;
        padding: 16px;
        border-radius: 16px;
        display: flex;
        align-items: center;
    }
    &__name {
        font-weight: 700;
        white-space: pre-wrap;
        line-height: 1.35;
    }
    &__link {
        text-align: right;
    }
}
@media (min-width: 1024px) {
    .domestic-organization {
        > li {
            &:not(:last-child) {
                padding-bottom: 80px;
            }
        }
        &__child {
            border-radius: 999px;
            padding: 8px;
        }
        &__name,
        &__tel {
            text-align: center;
        }
        &__tel,
        &__link {
            position: relative;
        }
        &__tel {
            &::before,
            &::after {
                content: "";
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                width: 1px;
                height: 24px;
                background-color: #ddd;
            }
            &::before {
                left: 0;
            }
            &::after {
                right: 0;
            }
        }
        &__address {
            padding-left: 24px;
            padding-right: 24px;
        }
        &__link {
            padding-left: 0;
            .v-btn {
                margin: 0 12px;
            }
            &::before {
                content: "";
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-50%);
                width: 1px;
                height: 24px;
                background-color: #ddd;
            }
        }
    }
}
</style>
